import { inputSearch } from "_constants";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useRef } from "react";
import { setSearchTermUtenti } from "store/slicer/GestioneUsersSlice";
import { useAppDispatch } from "store/store";

export const InputSearchUsersShareModal = () => {
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: any) => {
    dispatch(setSearchTermUtenti(inputRef.current?.value));
  };

  return (
    <IconField iconPosition="left">
      <InputIcon className="cta pi pi-search"></InputIcon>
      <InputText
        ref={inputRef}
        v-model="value1"
        placeholder={inputSearch}
        type="search"
        onKeyUp={handleChange}
        className="width-100"
      />
    </IconField>
  );
};
